import { render, staticRenderFns } from "./PromotionTierCondition.vue?vue&type=template&id=36d79054&"
import script from "./PromotionTierCondition.vue?vue&type=script&lang=js&"
export * from "./PromotionTierCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports